export interface ILeadResourcesApi {
    total: number;
    limit: number;
    skip: number;
    data: ILeadResource[];
}

export interface ILeadResource {
    id: number;
    providerId: number;
    fileLink: string;
    fileName: string;
    fileTitle: string;
    fileType: string;
    createdAt: string;
    updatedAt: string;
}

export enum UploadStatus {
    None,
    Saving,
    Error,
    Success,
}

export interface IUploadFiles {
    files: FileList | null;
    status: UploadStatus;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/interfaces/resources.ts